<template>
  <div class="animated fadeIn">
    <b-card>
    <b-row>
      <b-col cols="12">
          <div slot="header">
            <i class="icon-note"></i>Comprobante Diario
            <a
              v-if="!registro_no_encontrado || !no_visible"
              target="_blank"
              class="pull-right btn btn-sm btn-success text-white"
              style="cursor: pointer"
              @click="print()"
            >
              <i class="fa fa-print" /> Imprimir
            </a>

          </div>
      </b-col>
      <b-col cols="12">
        <b-alert :show="dismissCountDown"
                 dismissible
                 variant="danger"
                 @dismiss-count-down="countDownChanged">
          <span v-html="msj_validacion"></span> Será redirigido al listado de comprobantes en {{dismissCountDown}} segundos...
          <b-progress variant="info"
                      :max="dismissSecs"
                      :value="dismissCountDown"
                      height="4px">
          </b-progress>
        </b-alert>

      </b-col>
      <b-col cols="12" v-if="registro_no_encontrado">
            <b-card class="text-center">
              <div slot="header" class="text-center">
                <strong class="text-danger">Registro no encontrado</strong>
              </div>
              <h1>😪</h1>
            </b-card>
      </b-col>
       <b-col cols="12" v-else>
          <br>
          <visor-pdf v-show="cargado" :url="urlpdf" />
        </b-col>

    </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VisorPdf from "@/components/VisorPdf";
import toastr from "toastr";

export default {
  name: "pdf-comprobante",
   components: {
    VisorPdf
  },

  data() {
    return {
      id: parseInt(this.$route.params.id),
      nombre: this.$route.params.name,
      urlpdf:'',
      registro_no_encontrado:false,
      cargado:false,
      dismissSecs: 10,
      dismissCountDown: 0,
      no_visible:false,
      ruta_cancelar: '/comprobantes-diario',
      msj_validacion:'',
    };
  },
  methods: {
    cargarPdf() {
      if(this.id){
        let url_pdf_api =process.env.VUE_APP_API_REPORTES_URL;
        this.urlpdf =   `${url_pdf_api}pdf/comprobante?id=${this.id}`;
        this.cargado = true;
      }
    },
    async print(){
      try {
        // eslint-disable-next-line no-undef
        const response = await axios.post(this.urlpdf, {},{responseType: 'blob'});
        const url = window.URL.createObjectURL(new Blob([response.data],{type: "application/pdf"}));
        window.open(url);
      } catch(error){
        console.log("aca anda");
        console.log(error);
      }
    },
    async load(){
      try {
        // eslint-disable-next-line no-undef
        let {data,status} = await axios.post("/api/comprobantes/view", {id: this.id});
        if (status == 200) {
          if (!data || !data.data[0]) {
            this.registro_no_encontrado = true;
            return;
          }
          let datos = data.data[0];
            this.model = datos;
            if(this.model && this.model.empresa_id && parseInt(this.model.empresa_id) !== parseInt(this.empresaId)){
              console.log(this.model.empresa_id);
              console.log("vuex",this.empresaId);
              this.no_visible = true;
              let empresas =['Aldea Global', 'Aldea Coffee', 'AldeaZON'];
              let empresa_selecionada = empresas[parseInt(this.empresaId) -1];
              let empresa_comprobante = empresas[parseInt(this.model.empresa_id) -1];
              this.msj_validacion = `<strong>👀 El comprobante pertenece a otra empresa</strong>. Actualmente usted está en la empresa <strong>${empresa_selecionada}</strong> y el comprobante fue realizado en la empresa <strong>${empresa_comprobante}</strong>, cambie a esa empresa <strong>(${empresa_comprobante})</strong> y vuelva a intentarlo`;
              this.dismissSecs=20;
              this.countDownChanged(20);
              return;
            }
            this.cargarPdf();


        } else this.registro_no_encontrado = true;
      } catch (error) {
        toastr["error"](`Error :( ${error}`);
        console.log(error);
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if(this.dismissCountDown ===0){
        this.$router.push(this.ruta_cancelar);
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
  },
  mounted() {
    console.log(this.empresaId);
    this.load();
  }
};
</script>
<style lang="css">

</style>
